import { apiService } from './apiService';

export const ordersApi = {
    // Get all user's orders
    getOrders: async (params?: { page?: number; limit?: number; status?: string }) => {
        try {
            const queryParams = new URLSearchParams();
            if (params?.page) queryParams.append('page', params.page.toString());
            if (params?.limit) queryParams.append('limit', params.limit.toString());
            if (params?.status) queryParams.append('status', params.status);
            
            const url = `/orders/my-orders${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            return await apiService.get(url);
        } catch (error) {
            throw error;
        }
    },

    // Get order by ID
    getOrderById: async (orderId: string) => {
        try {
            return await apiService.get(`/orders/${orderId}`);
        } catch (error) {
            throw error;
        }
    },

    // Create a new order
    createOrder: async (orderData: any) => {
        try {
            return await apiService.post('/orders', orderData);
        } catch (error) {
            throw error;
        }
    },

    // Cancel an order
    cancelOrder: async (orderId: string) => {
        try {
            return await apiService.patch(`/orders/${orderId}/cancel`);
        } catch (error) {
            throw error;
        }
    },

    // Download invoice PDF
    downloadInvoice: async (orderId: string) => {
        try {
            const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';
            const response = await fetch(`${baseURL}/api/v1/invoices/pdf/${orderId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to download invoice');
            }

            const blob = await response.blob();
            return blob;
        } catch (error) {
            throw error;
        }
    },

    // Get product images for order
    getOrderProductImages: async (orderId: string) => {
        try {
            return await apiService.get(`/invoices/images/${orderId}`);
        } catch (error) {
            throw error;
        }
    },

    // Check if user owns a product
    checkProductOwnership: async (productId: string) => {
        try {
            return await apiService.get(`/orders/check-ownership/${productId}`);
        } catch (error) {
            throw error;
        }
    },

    // Check multiple products ownership (for batch checking)
    checkMultipleProductsOwnership: async (productIds: string[]) => {
        try {
            return await apiService.post('/orders/check-multiple-ownership', { productIds });
        } catch (error) {
            throw error;
        }
    },
};